"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loader_1 = __importDefault(require("../Loader"));
var helpers_1 = require("./helpers");
var styles_1 = require("./styles");
/**
 * Render button component.
 * @param variant Button type (each type has its own style).
 * @param disabled Flag that enable/disable button clicking.
 * @param loading Flag that determines if the Loader component renders or not.
 */
function Button(_a) {
    var _b = _a.as, Component = _b === void 0 ? "button" : _b, variant = _a.variant, format = _a.format, size = _a.size, disabled = _a.disabled, loading = _a.loading, children = _a.children, style = _a.style, className = _a.className, props = __rest(_a, ["as", "variant", "format", "size", "disabled", "loading", "children", "style", "className"]);
    var variantStyle = (0, helpers_1.getButtonVariantStyles)({
        variant: variant,
        format: format,
        size: size,
    });
    return (react_1.default.createElement(styles_1.ButtonContainer, __assign({ as: Component, disabled: disabled, style: style, className: className, variantStyle: variantStyle }, props), loading ? react_1.default.createElement(Loader_1.default, null) : children));
}
exports.default = Button;
//# sourceMappingURL=index.js.map